<template>
  <div class="o-focus o-tabs__tab--fixed-head">
    <div class="o-panel__header" v-my-fixed-title>
      <h3 class="o-panel__title">Delivering value for our customers</h3>
    </div>

    <my-slider>
      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body">
          <div class="o-focus__intro">
            <p>We understand the pressure that customers can be under. One in ten English households are in fuel poverty and, according to the government’s 2016 Fuel Poverty Statistics, all three regions served by our networks saw a rise in fuel poverty in the year. We recognise that when we spend money to operate, maintain or develop our network, we are spending our customers’ money, so we are careful to do so only when we have established that it is necessary. We aim to deliver the best service to our customers at the lowest cost. We do this by investing in our systems and processes. For example, our Business Transformation Project identified and developed smarter ways of working.</p>

            <p>This relentless focus on efficient expenditure means that our customers continue to enjoy the lowest domestic electricity distribution charges in the industry, alongside excellent reliability and top notch customer service.</p>
          </div>

          <div class="o-link__btn-group">
            <my-download-button :section="'focus-value-for-money'"></my-download-button>
          </div>
        </div>
      </my-slide>

      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body o-panel__body--full">
          <h4 class="o-chart__caption">Annual domestic charge for using our networks (2016/17)<br>
            <span class="o-chart__caption__subtitle">Domestic unrestricted customers based on average annual consumption of 3100 kWh</span></h4>
          <figure class="o-chart o-chart--focus">

            <my-chart :file="'domestic-charges'" :color="'red'" :chart-type="'bar'" :start-height="240" :skew="50" :padding="0.1" :margin="{top: 20, right: 0, bottom: 40, left: 0}"></my-chart>
          </figure>
        </div>
      </my-slide>

    </my-slider>

  </div>
</template>

<script>
import MyChart from '@/components/standard/my-chart'
import MyDownloadButton from '@/components/standard/my-download-button'
import { MySlider, MySlide } from '@/components/standard/my-slider'
import { MyFixedTitle } from '@/directives/my-fixed-title.js'

export default {
  name: 'my-focus-value',
  components: {
    MyChart,
    MyDownloadButton,
    MySlider,
    MySlide
  },
  directives: {
    MyFixedTitle
  }
}
</script>



// WEBPACK FOOTER //
// MyFocusValue.vue?1f4b4faf